import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { CLAIMS_STATE_KEY, IClaimsState } from '../reducers/claims.reducer';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { APPLICATION_CLAIMS, EClaimsGroup, TApplicationClaimMapKey } from '../../configurations/claims.config';

const claimsState = createFeatureSelector<IClaimsState>(CLAIMS_STATE_KEY);
const claims = createSelector(claimsState, (state) => state.claims);
const loading = createSelector(claimsState, (state) => state.loading);
const error = createSelector(claimsState, (state) => state.error);

const applicationClaimsByMapKey = (store: Store, key: TApplicationClaimMapKey | null): Observable<string[]> =>
  retrievedClaims(store).pipe(
    map((claims) => {
      if (!key || !APPLICATION_CLAIMS[key]) return [];

      const appClaims = Object.values(APPLICATION_CLAIMS[key]);
      const res = [];
      for (let i = 0; i < appClaims.length; i++) {
        if (claims.includes(appClaims[i])) {
          res.push(appClaims[i]);
        }
      }

      return res;
    }),
  );

const claimsByGroupName = (store: Store, key: EClaimsGroup): Observable<string[]> =>
  retrievedClaims(store).pipe(map((claims) => claims.filter((claim) => claim.startsWith(key))));

const retrievedClaims = (store: Store): Observable<string[]> =>
  store.select(claimsState).pipe(
    filter(({ loading, error }) => !loading && !error),
    switchMap(() => store.select(claims)),
  );
export const CLAIMS_SELECT = {
  claimsState,
  claims,
  loading,
  retrievedClaims,
  applicationClaimsByMapKey,
  claimsByGroupName,
  error,
};
